import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Styles from "../../homework/assets/Form.module.css";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";
import { ImageLink } from "../../../constants";
import CommonEditor from ".././CommonEditor";
import MultiImageUploader from "../../../components/chat/MultiImageUploader";
import Select from "react-select";
const AddBlogs = () => {
  const location = useLocation();
  const blogsData = location.state;
  const [formSubmitted, setFormSubmitted] = useState(false);
  const navigator = useNavigate();
  const [blogCategories, setBlogCategories] = useState([]);
  const fetchBlogCategories = async () => {
    try {
      const response = await axiosInstance.get(
        `admin/blogsCategory/getAllBlogCategories`,
      );
      const { data } = response.data;
      const options = data.map((cat) => ({
        value: cat._id,
        label: cat.title,
      }));
      setBlogCategories(options);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  React.useEffect(() => {
    fetchBlogCategories();
  }, []);
  const [data, setData] = useState({
    title: blogsData?.title || "",
    description: blogsData?.description || "",
    isActive: blogsData?.isActive ?? true,
    url: blogsData?.url || "",
    coverImage: blogsData?.coverImage || "",
    metaTitle: blogsData?.metaTitle || "",
    metaKeywords: blogsData?.metaKeywords || "",
    metaDescription: blogsData?.metaDescription || "",
    category: blogsData?.category
      ? { value: blogsData.category._id, label: blogsData.category.title }
      : null,
  });
  const [images, setimages] = useState(blogsData?.images || []);
  const handleChange = (e) => {
    const { name, files, type, checked, value } = e.target;

    if (type === "file") {
      setData({ ...data, [name]: files?.[0] || null });
    } else if (type === "checkbox" || type === "switch") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!data.coverImage) {
      return;
    }
    if (!data.category) {
      toast.error("Please select a blogs category");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("isActive", data.isActive);
      formData.append("metaTitle", data.metaTitle);
      formData.append("metaKeywords", data.metaKeywords);
      formData.append("metaDescription", data.metaDescription);
      formData.append("coverImage", data.coverImage);
      formData.append("url", data.url);
      formData.append("category", data.category.value);
      images.forEach((file) => {
        formData.append("images", file);
      });

      const response = await axiosInstance.post(
        `admin/blogs/createBlog`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator(-1);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!data.title) {
      return;
    }
    if (!data.category) {
      toast.error("Please select a blogs category");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("isActive", data.isActive);
      formData.append("metaTitle", data.metaTitle);
      formData.append("metaKeywords", data.metaKeywords);
      formData.append("metaDescription", data.metaDescription);
      formData.append("url", data.url);
      formData.append("category", data.category.value);
      if (data.coverImage instanceof File) {
        formData.append("coverImage", data.coverImage);
      }

      if (images && images.length > 0) {
        images.forEach((file) => {
          formData.append("images", file);
        });
      } else {
        formData.append("images", []);
      }

      const response = await axiosInstance.put(
        `admin/blogs/updateBlog/${blogsData?._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        navigator(-1);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Something went wrong");
    }
  };
  return (
    <div>
      <div className="mt-4 mb-4">
        <div className="row">
          <div className="col-sm-6">
            <h4 className="page-title">
              {blogsData?._id ? "Edit Blogs" : "Add Blogs"}
            </h4>
          </div>
        </div>
        <Card className="mt-4">
          <CardBody>
            <Row>
              <Col md="12">
                <form
                  className="ps-5 pe-5 pt-3"
                  onSubmit={blogsData?._id ? handleUpdate : handleSubmit}
                >
                  <div className="row form-group">
                    <div className="col-sm-4 mb-4">
                      <Label for="blogsTitle" className="col-form-label">
                        Title
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="blogsTitle"
                        placeholder="Enter Title"
                        invalid={!blogsData && !data.title && formSubmitted}
                        name="title"
                        value={data.title}
                        onChange={(e) => handleChange(e)}
                      />
                      <FormFeedback>Title is required</FormFeedback>
                    </div>

                    <div className="col-sm-4 mb-4">
                      <Label for="category" className="col-form-label">
                        Blogs Category
                      </Label>
                      <Select
                        id="category"
                        name="category"
                        value={data.category}
                        onChange={(selected) =>
                          setData({ ...data, category: selected })
                        }
                        options={blogCategories}
                        isClearable
                        placeholder="Select a category"
                        classNamePrefix="react-select"
                      />
                      {formSubmitted && !data.category && (
                        <FormFeedback style={{ display: "block" }}>
                          Blogs category is required
                        </FormFeedback>
                      )}
                      {formSubmitted && !data.category && (
                        <FormFeedback style={{ display: "block" }}>
                          Blogs category is required
                        </FormFeedback>
                      )}
                    </div>

                    <div className="col-sm-4 mb-4">
                      <Label for="blogsUrl" className="col-sm-4 col-form-label">
                        Url
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="blogsUrl"
                        placeholder="Enter Url"
                        name="url"
                        value={data.url}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>

                    <div className="col-sm-12 mb-4">
                      <Label for="img" className="col-form-label">
                        Cover Image
                      </Label>
                      <Input
                        type="file"
                        id="img"
                        name="coverImage"
                        invalid={
                          !blogsData && !data.coverImage && formSubmitted
                        }
                        onChange={(e) => handleChange(e)}
                      />
                      <FormFeedback>Cover image is required</FormFeedback>
                      {data.coverImage && (
                        <div className="w-100 h-15 text-left mt-2">
                          {data.coverImage instanceof File ? (
                            <img
                              src={URL.createObjectURL(data.coverImage)}
                              alt="Preview"
                              className="mt-4"
                              style={{ width: "25%" }}
                            />
                          ) : (
                            <img
                              src={ImageLink(data.coverImage)}
                              alt="Preview"
                              className="mt-4"
                              style={{ width: "25%" }}
                            />
                          )}
                        </div>
                      )}
                    </div>

                    <div className="col-sm-12 mb-4 mt-2">
                      <Label for="description" className="col-form-label">
                        Description
                      </Label>
                      <CommonEditor
                        value={data.description}
                        placeholder="Enter subject description..."
                        onChange={(value) =>
                          handleChange({
                            target: { name: "description", value },
                          })
                        }
                      />
                    </div>

                    <div className="col-sm-6 mb-4">
                      <Label for="metaTitle" className="col-form-label">
                        Meta Title
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="metaTitle"
                        placeholder="Enter subject meta title"
                        name="metaTitle"
                        invalid={!blogsData && !data.metaTitle && formSubmitted}
                        value={data.metaTitle}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>Blogs meta title is required</FormFeedback>
                    </div>
                    <div className="col-sm-6 mb-4">
                      <Label for="metaKeywords" className="col-form-label">
                        Meta Keywords
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="metaKeywords"
                        placeholder="Enter subject meta keywords"
                        name="metaKeywords"
                        invalid={
                          !blogsData && !data.metaKeywords && formSubmitted
                        }
                        value={data.metaKeywords}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>
                        Blogs meta keywords is required
                      </FormFeedback>
                    </div>
                    <div className="col-sm-12 mb-4">
                      <Label for="metaDescription" className="col-form-label">
                        Meta Description
                      </Label>
                      <Input
                        type="textarea"
                        className="form-control"
                        id="metaDescription"
                        placeholder="Enter subject meta description"
                        name="metaDescription"
                        invalid={
                          !blogsData && !data.metaDescription && formSubmitted
                        }
                        value={data.metaDescription}
                        onChange={(e) => handleChange(e)}
                        rows={5}
                      />
                      <FormFeedback>
                        Blogs meta description is required
                      </FormFeedback>
                    </div>

                    <div className="col-sm-12">
                      <Label for="img" className="col-form-label">
                        Description Images
                      </Label>

                      <MultiImageUploader
                        maxImages={10}
                        initialImages={images}
                        onChange={(imgs) => setimages(imgs)}
                      />
                    </div>
                    <br />
                    <div className="col-sm-4 mb-4">
                      <Label for="isActive" className="col-sm-4 col-form-label">
                        isActive
                      </Label>
                      <div className="col-sm-8">
                        <FormGroup switch>
                          <Input
                            type="switch"
                            id="isActive"
                            name="isActive"
                            checked={data.isActive}
                            onChange={handleChange}
                            className={`${Styles.form_check_input}`}
                          />
                          <Label check className="mx-1">
                            {data.isActive ? "Active" : "Deactive"}
                          </Label>
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-4">
                    <Label
                      for="inputPassword"
                      className="col-sm-4 col-form-label"
                    >
                      <b className="ms-2"></b>
                    </Label>
                    <div className="col-sm-7 d-flex">
                      <div className={`${Styles.submit_button}`}>
                        <Button type="submit">
                          {blogsData?._id ? "Update" : "Save"}
                        </Button>
                      </div>
                      <div className={`${Styles.cancel_button} me-4 mx-2`}>
                          <Button className={`${Styles.cancel_button}`} onClick={() => navigator(-1)}>
                            Cancel
                          </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default AddBlogs;
